const MIX_DURATION_SECONDS = 15 * 60;
const MAX_REASONABLE_SECONDS = 12 * 60 * 60;

const normalizeNumericDuration = (duration: number): number => {
    if (!Number.isFinite(duration) || duration < 0) return 0;
    // Provider and legacy playlist payloads have used both seconds and
    // milliseconds. Values beyond twelve hours are treated as milliseconds;
    // this prevents an ordinary 180000ms song from becoming a 50-hour "mix".
    return duration > MAX_REASONABLE_SECONDS ? duration / 1000 : duration;
};

export const durationToSeconds = (duration: string | number | null | undefined): number => {
    if (typeof duration === "number") {
        return normalizeNumericDuration(duration);
    }

    const normalized = String(duration || "").trim();
    if (!normalized) return 0;
    if (!normalized.includes(":")) {
        const seconds = Number(normalized);
        return normalizeNumericDuration(seconds);
    }

    const parts = normalized.split(":").map(Number);
    if (parts.some((part) => !Number.isFinite(part) || part < 0)) return 0;
    return parts.reduce((total, part) => total * 60 + part, 0);
};

export const isMixDuration = (duration: string | number | null | undefined): boolean =>
    durationToSeconds(duration) > MIX_DURATION_SECONDS;
